import gql from 'graphql-tag';
import { UserAllDataFragment } from '../fragments';

export default gql`
mutation grantAdminRightToUser (
    $id: ID!
) {
    grantAdminRightToUser (
        id: $id
    ) {
        ...UserAllDataFragment
    }
}
${UserAllDataFragment}
`;



// WEBPACK FOOTER //
// ./src/api/graphql/mutations/grantAdminRightToUser.ts